import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text:  'Image',
          value: 'itemImage',
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Key",
          value: "key",
        },
         {
          text:  'Type',
          value: 'type',
        },
         {
          text:  'Price',
          value: 'itemPrice',
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
     
    ],
    table: {
      headers: [
        {
          text:  'Image',
          value: 'itemImage',
        },
        {
          text: "Name",
          value: "translatableName",
        },
        {
          text: "Key",
          value: "key",
        },
         {
          text:  'Type',
          value: 'type',
        },
         {
          text:  'Price',
          value: 'itemPrice',
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add:false,
  edit:true,
  delete: true,
};
